import React, { useEffect, useState, useMemo } from "react"
import { Typography, MenuItem, ListItem,  FormControlLabel, Checkbox } from '@mui/material'
import { ExpandMore } from '@mui/icons-material'
import PopoverMenu from '../ui/menuPopover/MenuPopover'
import ButtonActive from '../ui/ButtonActive'
import styles from './FilterCheckBox.module.scss'

export default function FilterCheckbox({ filterItems, returnFilteredItems, itemId = "uuid", filterKey, filterKeyArray, filterLabel, menuAnchorEl, setMenuAnchorEl }) {
    const [filterForm, setFilterForm] = useState({})
    const [filterMemo, setFilterMemo] = useState({})

    // Update filter state
    const handleFilter = (e) => {
        setFilterForm((state) => ({ ...state, [e.target.name]: e.target.checked }))
    }

    // Clear filter case
    const clearFilter = () => {
        const resetFilter = { ...filterForm }
        Object.keys(resetFilter).forEach(key => { resetFilter[key] = false })
        setFilterForm(resetFilter)
        handleFilterMenuClose()
    }

    // Menu behaviour
    const handleFilterMenuButton = (e) => {
        setMenuAnchorEl(e.currentTarget)
    }
    const handleFilterMenuClose = () => {
        setMenuAnchorEl(null)
    }

    // Build filter state and memory
    useEffect(() => {
        if (filterItems) {
            let form = { ...filterForm }
            let memo = { ...filterMemo }
            const addToMemo = (optionKey, id) => {
                memo[optionKey] = memo[optionKey] || []
                memo[optionKey].push(id)
            }
            const addToForm = (optionKey) => {
                form[optionKey] = form[optionKey] || false // i.e. form.APPL = false
            }
            filterItems.forEach((item) => {
                if (item[filterKey]) {
                    addToForm(item[filterKey])
                    addToMemo(item[filterKey], item[itemId])
                }
                filterKeyArray && item[filterKeyArray] && item[filterKeyArray].forEach((key) => {
                    addToForm(key)
                    addToMemo(key, item[itemId])
                })
            })
            setFilterForm(form)
            setFilterMemo(memo)
        }
        return () => {}
    }, [filterItems]) // eslint-disable-line

    const itemsList = useMemo(() => (
        filterItems?.map(item => item[itemId]) || []
    ),[filterItems, itemId])
    
    const filterIsActive = useMemo(() => (
        Object.values(filterForm).includes(true)
     ), [filterForm])

    // Update parent with filtered items id list
    useEffect(() => {
        returnFilteredItems(
            filterIsActive
                ? Object.keys(filterForm)
                    .filter(key => filterForm[key])
                    .reduce((acc, cur) => [...acc, ...filterMemo[cur]], [])
                : itemsList
        )
        return () => {}
    }, [ filterForm, filterIsActive, itemsList]) // eslint-disable-line
    
    const filterMenuItems = useMemo(() => (
        Object.keys(filterForm)
            .sort()
            .map(key => (
            <ListItem classes={{root: styles['checkboxListItem']}} key={`${key}-filteroption`}>
                <FormControlLabel
                    control={<Checkbox checked={filterForm[key]} onChange={handleFilter} name={key} />}
                    label={`${key}`}
                />
            </ListItem>
            )).concat(
                <MenuItem classes={{root: styles['menuItem']}} key="clear-filteroption" onClick={clearFilter}>
                    <Typography variant="overline">
                        Clear
                    </Typography>
                </MenuItem>
            )
    ), [filterForm]) // eslint-disable-line

    return (
        <div key={`${filterKey}FilterButton`}>
            <ButtonActive
                classes={{root: styles['filterButton']}}
                variant="contained"
                onClick={handleFilterMenuButton}
                endIcon={<ExpandMore />}
                $active={filterIsActive}
                color={menuAnchorEl?.name === filterKey ? 'primary' : 'secondary'}
            >
                { filterLabel }
            </ButtonActive>
            <PopoverMenu
                anchorEl={menuAnchorEl}
                onClose={handleFilterMenuClose}
            >
                { filterMenuItems }
            </PopoverMenu>
        </div>
    )
}